<div class="container mx-auto px-0 py-0">
  <div class="bg-white rounded-lg" [ngClass]="{'shadow-md p-6': !isEmbedded, 'p-0': isEmbedded}">
    <!-- Standalone Header - Only show in standalone mode -->
    <div *ngIf="!isEmbedded" class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon>contacts</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Kontakte</h2>
      </div>
      <div class="flex justify-end">
        <button 
          (click)="addKontakt()" 
          mat-stroked-button>
          <mat-icon class="mr-1">add</mat-icon>
          Kontakt hinzufügen
        </button>
      </div>
    </div>
    
    <!-- Embedded Header - Only show in embedded mode -->
    <div *ngIf="isEmbedded" class="flex justify-end mb-4 mt-4">
      <button 
        (click)="addKontakt()" 
        mat-stroked-button>
        <mat-icon class="mr-1">add</mat-icon>
        Kontakt hinzufügen
      </button>
    </div>

  
  <!-- Loading Spinner -->
  <div *ngIf="isLoadingResults" class="flex justify-center items-center py-8">
    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    <span class="ml-4 text-gray-600">Lade Kontakte...</span>
  </div>

  <!-- Error Message -->
  <div *ngIf="isRateLimitReached" class="text-red-500 text-center py-4">
    Fehler beim Laden der Kontakte. Bitte versuchen Sie es später erneut.
  </div>

  <!-- Contacts Table -->
  <div class="mt-8 flow-root" *ngIf="!isLoadingResults && !isRateLimitReached">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <table class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
          <thead>
            <tr>
              <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Name</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Email</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Telefon</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Mobile</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Ort</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Status</th>
              <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                <span class="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
                          <tr 
                *ngFor="let kontakt of dataSource.data; let i = index" 
                (click)="editKontakt(kontakt)"
                class="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">{{ kontakt.name }}</td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ kontakt.email || '-' }}</td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ kontakt.telefon || '-' }}</td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ kontakt.mobile || '-' }}</td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ kontakt.ort || '-' }}</td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                        [ngClass]="getStatusClasses(kontakt.status_id)">
                    {{ getStatusText(kontakt.status_id) }}
                  </span>
                </td>
                <td class="whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                <button
                  (click)="editKontakt(kontakt); $event.stopPropagation()"
                  mat-button
                  color="primary"
                  class="slim-button">
                  Bearbeiten
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Paginator -->
  <mat-paginator
    *ngIf="!isLoadingResults && !isRateLimitReached"
    [length]="totalItems"
    [pageSizeOptions]="pageSizes"
    [pageSize]="10"
    (page)="onPageChange()"
    showFirstLastButtons
    aria-label="Select page of contacts">
  </mat-paginator>

  <!-- Empty State -->
  <div *ngIf="!isLoadingResults && !isRateLimitReached && dataSource.data.length === 0" class="text-center py-8">
    <mat-icon class="text-gray-400 text-6xl mb-4">contacts</mat-icon>
    <p class="text-gray-500 text-lg">Keine Kontakte gefunden</p>
    <p class="text-gray-400">Fügen Sie den ersten Kontakt hinzu, um zu beginnen.</p>
  </div>
  </div>
</div>
